export default __webpack_public_path__ + "static/media/working.42c2799f.jpg";